"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Button } from "@/src/components";
import { PageHeader } from "@/src/components/layout/page-header";

export default function DocsBlocksPageHeader() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Page Header
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A flexible page header component with slots for title, logo, and actions.
          </Text>
        </div>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Page header with actions</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="border rounded-lg p-4">
            <PageHeader
              title="Users"
              rightButtons={
                <Button size="sm" onClick={() => console.log("Add user")}>
                  Add User
                </Button>
              }
            />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>With Back Button</CardTitle>
              <CardDescription>Page header with navigation</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="border rounded-lg p-4">
            <PageHeader
              title="User Details"
              onBack={() => console.log("Back clicked")}
              rightButtons={[
                <Button key="cancel" size="sm" variant="outline" onClick={() => {}}>
                  Cancel
                </Button>,
                <Button key="save" size="sm" onClick={() => console.log("Save")}>
                  Save
                </Button>,
              ]}
            />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">title</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Page title</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">logo</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">LogoProps | ReactNode</td>
                <td className="py-2 text-muted-foreground">Logo element or props</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">rightButtons</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode | ReactNode[]</td>
                <td className="py-2 text-muted-foreground">Buttons/content on the right side</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onBack</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">() =&gt; void</td>
                <td className="py-2 text-muted-foreground">Back button handler</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
